"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Playground = void 0;
var env_1 = require("./env");
var index_1 = require("../mesh/index");
var Playground = /** @class */ (function () {
    function Playground(base) {
        this.base = base;
        this.ready = false;
        this.init();
    }
    Playground.prototype.init = function () {
        var _this = this;
        this.base.getResources().then(function () {
            _this.env = new env_1.Env(_this.base);
            _this.donuts = new index_1.Donuts(_this.base);
            _this.ready = true;
        });
    };
    Playground.prototype.update = function (clock) {
        if (this.ready) {
            this.env.update(clock);
            this.donuts.update(clock);
        }
    };
    return Playground;
}());
exports.Playground = Playground;
